import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetPrincipals({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("PRINCIPAL_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/principal", option);
    commit("PRINCIPAL_SUCCESS", _response);
  } catch (error) {
    commit("PRINCIPAL_ERROR", { result: error.message });
  }
}

export async function CreatePrincipal({ commit }, form) {
  try {
    ApiService.init();
    commit("CREATE_PRINCIPAL_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/principal", form);
    commit("CREATE_PRINCIPAL_SUCCESS", { results: _response });
    Message({
      message: "Create completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("CREATE_PRINCIPAL_ERROR", { result: error.message });
  }
}

export async function GetPrincipal({ commit }, id) {
  try {
    ApiService.init();
    commit("GET_PRINCIPAL_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get("/principal", id);
    commit("GET_PRINCIPAL_SUCCESS", { results: _response });
  } catch (error) {
    commit("GET_PRINCIPAL_ERROR", { result: error.message });
  }
}

export async function UpdatePrincipal({ commit }, form) {
  try {
    ApiService.init();
    commit("EDIT_PRINCIPAL_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/principal/" + form.id, form);
    commit("EDIT_PRINCIPAL_SUCCESS", { results: _response });
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_PRINCIPAL_ERROR", { result: error.message });
  }
}

export async function DeletePrincipal({ commit }, id) {
  try {
    ApiService.init();
    commit("DELETE_PRINCIPAL_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/principal/" + id);
    commit("DELETE_PRINCIPAL_SUCCESS", { id: id });
    Message({
      message: "Delete completed",
      type: "success"
    });
  } catch (error) {
    commit("DELETE_PRINCIPAL_ERROR", { result: error.message });
  }
}
